import { render, staticRenderFns } from "./produce.vue?vue&type=template&id=dbc44572"
import script from "./produce.vue?vue&type=script&lang=js"
export * from "./produce.vue?vue&type=script&lang=js"
import style0 from "./produce.vue?vue&type=style&index=0&id=dbc44572&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports